import './ErrorComponent.css';

export default function ErrorComponent({ error }) {
  return (
    console.log("Details in ErrorComponent:", error),
    <div className="error-container">
      <h2>Not Found</h2>
      <p>{error.error || "An unexpected error has occurred."}</p>
    </div>
  );
}